import axios from "axios";
import isEmpty from "lodash/isEmpty";
import { REACT_APP_API_URL, REACT_APP_SITE_KEY } from "../../shared/vars";

export const eNewsInProcess = () => {
	return {
		type: "ENEWS_IN_PROCESS"
	};
};

export const eNewsHasError = err => {
	return {
		type: "ENEWS_HAS_ERROR",
		errors: err
	};
};

export const eNewsSuccess = data => {
	return {
		type: "ENEWS_SUCCESS",
		data
	};
};

export function submitENewsSignup(state) {
	return dispatch => {
		dispatch(eNewsInProcess());

		const AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY };

		// Set up request params
		const params = {
			email: state.email,
			fname: state.fname,
			lname: state.lname
		};

		return axios
			.post(REACT_APP_API_URL + "enewsletter/list", params, { headers: AUTH_HEADER })
			.then(response => {
				// Error explicitly set
				if (!isEmpty(response.data.errors)) {
					dispatch(eNewsHasError(response.data.errors));

					// Error status
				} else if (!!response.data.status && response.data.status !== 200) {
					dispatch(eNewsHasError({ general: response.data.message }));

					// Success
				} else {
					dispatch(eNewsSuccess(response.data));
				}
			})
			.catch(err => {
				console.log("eNews error:", err.response);
				dispatch(eNewsHasError(err.response.data.message));
			});
	};
}



// WEBPACK FOOTER //
// ./src/store/actions/enews.js